import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SubmissionSummaryService } from '../../data-access/services/submission-summary.service';

@Component({
  selector: 'app-userdefined-summary',
  templateUrl: './userdefined-summary.component.html',
  styleUrls: ['./userdefined-summary.component.scss'],
  standalone: false,
})
export class UserdefinedSummaryComponent implements OnInit {
  aggregateWriteInCount = 0;
  @Input() currentYear!: number;
  @Input() prfNumber!: string;
  @Input() groupCode!: string;
  userdefiledcols: any[] = [];
  userdefined_direct_total: any;
  userdefined_supplemental_total: any;
  userDefinedColsLoaded: boolean = false;
  userdefinedDataLoaded: boolean = false;
  constructor(
    private readonly router: Router,
    private readonly submissionSummaryService: SubmissionSummaryService
  ) {}
  ngOnInit(): void {
    this.loadPremiumDetails();
    this.loadUserdefinedColumns();
  }
  private loadUserdefinedColumns() {
    this.submissionSummaryService
      .loadUserdefinedColumns(this.currentYear, this.prfNumber)
      .subscribe({
        next: (lobdetails) => {
          if (lobdetails) {
            this.userdefiledcols = lobdetails;
            this.userDefinedColsLoaded = true;
            console.log('userdefiledcols', this.userdefiledcols);
          } else {
            this.userDefinedColsLoaded = false;
          }
        },
        error: (error) => {
          this.userDefinedColsLoaded = false;
          this.router.navigate(['/apifailure']);
        },
      });
  }
  private loadPremiumDetails() {
    this.submissionSummaryService
      .loadPremiumDetails(this.prfNumber, this.currentYear, this.groupCode)
      .subscribe((result) => {
        if (result) {
          this.userdefined_direct_total = result.userdefined_premium;
          this.userdefined_supplemental_total =
            result.userdefined_premium_supplemental;
          this.userdefinedDataLoaded = true;
        }
      });
  }
  navigateToUserdefinedData() {
    this.router.navigate([
      `/${this.currentYear}/${encodeURIComponent(
        this.prfNumber
      )}/userdefineddata`,
    ]);
  }
}
